import { useController } from "react-hook-form";
import { FieldMessage, FormFieldWrapper } from "components/layout/forms/FormField";
import { SearchSelect } from "components/layout/forms/fields/Autocomplete/SearchSelect";
import { gql, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { useOrganisation } from "../../providers/OrganisationProvider";

export const GET_EVENT_TEAMS = gql`
  query getEventTeams($id: ID!) {
    event(id: $id) {
      id
      teams {
        id
        name
      }
    }
  }
`;

export const TeamsSelectorField = ({ field, control, setValue }) => {
    const { id } = useParams();
    const organisation = useOrganisation();
    const { data } = useQuery(GET_EVENT_TEAMS, { variables: { id } });

    const { field: inputField, fieldState } = useController({
        control,
        name: field.name,
        defaultValue: null,
        rules: { validate: value => value ? undefined : "You must select a team" }
    });

    const teamsField = {
        options: data?.event?.teams.map(team => ({ label: team.name, value: team.id })) || [],
        placeholder: "Type your team name...",
        loading: !data,
        noOptions: {
            message: "no_team_found_contact_organisation",
            messageValues: { contact: organisation.contactEmail }
        },
        autocompleteProps: {
            filterSelectedOptions: true,
            blurOnSelect: true
        },
    };

    const input = {
        value: teamsField.options.find(option => option.value === inputField.value) || null,
        onChange: option => {
            inputField.onChange(option?.value || null);
            setValue("team.name", option?.label);
        }
    };

    return (
        <FormFieldWrapper label="Select your team" >
            <SearchSelect field={teamsField} input={input} />
            <FieldMessage errorMessage={fieldState.error?.message}/>
        </FormFieldWrapper>
    );
};
